import { Injectable } from '@angular/core';

import { UUIDService } from '../uuid/uuid.service';

@Injectable({
  providedIn: 'root'
})
export class AppUuidService {
  private uuid: string = null;

  constructor(private uuidService: UUIDService) {
    this.uuid = this.uuidService.get();
  }

  get appUuid(): string {
    return this.uuid;
  }
}
